import { routes } from "src/shared/routes";
import {
  FAQS,
  FOOTER_LINKS,
  SWAF_INFO_TEXT,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  CHECKOUT_TERMS_AND_CONDITION,
  BUYER_HOW_IT_WORKS,
  SELLER_HOW_IT_WORKS,
  MARKETPLACE_FAQS,
  ListingCheckoutTermsAndCondition,
  CreateListingTermsAndCondition,
} from "../gators_students/helper";
import { constants } from "src/shared/constants";

const desktopBannerImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/2025-26%20v3%20Assets/Florida%20Student%20Tickets/AUG21-1920x450.jpg";
const mobileBannerImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/2025-26%20v3%20Assets/Florida%20Student%20Tickets/AUG21-375x500.jpg";

import marketplaceHomeBannerImage from "public/images/gators/gators_marketplace_home_banner.jpeg";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const TEAM_SCHEMA = "gators_students_2";

export const gators_students_2: TTeamConfig = {
  TEAM_SCHEMA: "gators_students_2",
  TEAM_FULL_NAME: "University of Florida",
  BROWSER_TITLE: "Florida Gators Student Tickets",
  CLIENT_ID: "0cc9a385a0f8.seasonshare.gators-gators.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,
  MARKETPLACE_VENDOR: constants.vendorUUIDs.stripe,

  TEAM_GLOBAL_SETTINGS: {
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/gators",
    COLORS_PRIMARY: "#0021A5",
    COLORS_SECONDARY: "#FA4616",
    DEFAULT_APP_ROUTE: routes.home,
    DEFAULT_APP_ROUTE_AFTER_LOGIN: routes.home,
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    IS_CROWD_HANDLER_ENABLED: true,
    IS_MARKETPLACE_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    FOOTER: {
      LINKS: FOOTER_LINKS,
    },

    IS_INTERCOM_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      HIDE_SECTION_TITLE: true,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: false,
    },

    ZERO_STATE: {
      TITLE: " ",
      DESCRIPTION:
        "No events are currently available for purchase. Please check back later.",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,

    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <TERMS_AND_CONDITION />,
    },
  },

  MY_GROUP_PAGE_SETTINGS: {
    PAGE_INFO_TEXT: <SWAF_INFO_TEXT />,
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  PURCHASE_HISTORY_PAGE_SETTINGS: {
    PURCHASE_HISTORY_ZERO_STATE: {
      TITLE: "No orders yet",
      DESCRIPTION: "Only purchases made on this platform will appear here.",
    },
  },

  MARKETPLACE_GLOBAL_SETTINGS: {
    BUYER_HOW_IT_WORKS,
    SELLER_HOW_IT_WORKS,
    FAQS: MARKETPLACE_FAQS(TEAM_SCHEMA),
    MARKETPLACE_REDIRECT_WARN_MODAL_DESCRIPTION:
      "You’re entering a peer-to-peer marketplace where students can buy and sell tickets directly with each other. Prices are set by fellow students and are not regulated or controlled by the University of Florida.",
    STRIPE_KYC_CONFIRMATION_MODAL_DESCRIPTION:
      "The University of Florida and Attend use Stripe as a secure payment processor. You’re about to leave this page to complete seller onboarding, where we’ll collect your name, address, phone number, and bank details so we can deposit your payout once your ticket sells.",

    LISTING_CHECKOUT_TERMS_AND_CONDITION: <ListingCheckoutTermsAndCondition />,
    CREATE_LISTING_TERMS_AND_CONDITION: <CreateListingTermsAndCondition />,
  },

  MARKETPLACE_HOME_PAGE_SETTINGS: {
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: false,
    },

    BECOME_SELLER_CARD: {
      TITLE: "Sell Your Student Ticket",
      DESCRIPTION:
        "Got a student ticket you can’t use? Sell it to another student and make sure your seat is filled with school spirit. List your ticket in seconds and enjoy a quick, secure process that turns your unused ticket into extra cash.",
      BUTTON_TEXT: "Sell Your Ticket",
    },

    BECOME_BUYER_CARD: {
      TITLE: "Buy a Student Ticket",
      DESCRIPTION:
        "Looking for a ticket to the big game or event? Browse listings from fellow students and grab your seat in the student section. Enjoy a safe, hassle-free purchase and join your classmates in the action.",
      BUTTON_TEXT: "Browse Listings",
    },
  },

  MARKETPLACE_EVENTS_PAGE_SETTINGS: {
    PAGE_INFO_TEXT:
      "Click on a game to browse the available student tickets—after purchasing another student’s ticket; your ticket with seat locations will be delivered the Friday before gameday.",
    CART: {
      MAX_LISTINGS_COUNT: 5,
    },
  },

  MARKETPLACE_CREATE_LISTING_PAGE_SETTINGS: {
    PAGE_INFO_TEXT:
      "List your student tickets for upcoming games and check back here to track their status — only student tickets can be listed.",
  },

  IMAGES: {
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/NCAA/u-florida-gators.png",
    LANDING_PAGE_STATIC_BANNER_URL: desktopBannerImage,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: mobileBannerImage,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: desktopBannerImage,
    ORDER_SUMMERY_BACKGROUND_URL: desktopBannerImage,
    MARKETPLACE_HOME_PAGE_STATIC_BANNER_URL: marketplaceHomeBannerImage.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION: CHECKOUT_TERMS_AND_CONDITION,
  },
};
